import type { LibraryScope } from './LibraryScopeSwitch';

export type LibraryCategory = 'ready' | 'images' | 'uploadedVideos' | 'audio' | 'characters' | 'scenarioTemplates' | 'disk';

const personalCategories: Array<[LibraryCategory, string]> = [
  ['ready', 'Готовые'], ['characters', 'Персонажи'], ['images', 'Изображения'],
  ['uploadedVideos', 'Загруженные видео'], ['audio', 'Аудио'], ['scenarioTemplates', 'Шаблоны сценариев']
];
const sharedCategories: Array<[LibraryCategory, string]> = [
  ['characters', 'Персонажи']
];

export function LibraryCategoryTabs({ scope, value, onChange }: { scope: LibraryScope; value: LibraryCategory; onChange: (value: LibraryCategory) => void }) {
  const categories=scope==='shared'?sharedCategories:personalCategories;
  return <div className="library-tabs media-disk-tabs" data-scope={scope} aria-label="Категории библиотеки">
    {categories.map(([category, label]) => <button type="button" key={category} className={value === category ? 'active' : ''} onClick={() => onChange(category)}>{label}</button>)}
  </div>;
}
